export default "__VITE_ASSET__DsSrtcKu__"